import { createRouter, createWebHashHistory } from 'vue-router';

import Home from '../views/index.vue';
import store from '../store';

// Vue.use(VueRouter);
// import { createApp } from 'vue';
// const app = createApp();
// app.use(createRouter);

const routes = [
    //dashboard
    {
        path: '/',
        name: 'login',
        component: () => import('../views/login.vue'),
        meta: { layout: 'auth' },
    },
    { path: '/home', name: 'Home', component: Home },

      {
        path: '/boq',
        name: 'boq',
        component: () => import('../views/boq'),
    },


    {
        path: '/bulk-statements',
        name: 'bulk-statements',
        component: () => import('../views/distribution/bulk_statements.vue'),
    },

     {
        path: '/cards',
        name: 'cards',
        component: () => import('../views/cards/'),
    },


    {
        path: '/machine-statement/:distribution_id',
        name: 'machine-statement',
        component: () => import('../views/distribution/machine_statement.vue'),
    },

    // =========== assets ===========================

    {
        path: '/assets/list',
        name: 'assets-list',
        component: () => import('../views/assets/list.vue'),
    },

        {
        path: '/assets/bincards',
        name: 'assets-bincards',
        component: () => import('../views/assets/bincards.vue'),
    },

            {
        path: '/asset/bincards/:asset_id',
        name: 'asset-bincards',
        component: () => import('../views/assets/bincard.vue'),
    },


     {
        path: '/asset/jobcards/:asset_id',
        name: 'asset-jobcards',
        component: () => import('../views/jobcards/asset_jobcards.vue'),
    },


                {
        path: '/asset/profile/:asset_id',
        name: 'asset-profile',
        component: () => import('../views/assets/profile.vue'),
    },


    // ==================== assets =======================


    {
        path: '/bulk-distribution/:store_id',
        name: 'bulk',
        component: () => import('../views/distribution/bulk_distribution.vue'),
    },

    {
        path: '/direct-filling/',
        name: 'direct-filling',
        component: () => import('../views/distribution/direct_fill.vue'),
    },



    {
        path: '/direct-fill-statement/:distribution_id',
        name: 'direct-fill-statement',
        component: () => import('../views/distribution/direct_fill_statement.vue'),
    },

  {
        path: '/jobcard/:jobcard_id/:machine_id',
        name: 'jobcard',
        component: () => import('../views/jobcards/jobcard.vue'),
    },
    {
        path: '/jobcards',
        name: 'jobcards',
        component: () => import('../views/jobcards/jobcard_list.vue'),
    },

     {
        path: '/jobcards/outside-maintenances',
        name: 'jobcards-outside-maintenances',
        component: () => import('../views/jobcards/outsideMaintenances.vue'),
    },

        {
        path: '/jobcards/asset-consumption',
        name: 'jobcards-asset-consumption',
        component: () => import('../views/jobcards/assetConsumption.vue'),
    },
    {
        path: '/orders',
        name: 'orders',
        component: () => import('../views/orders/preview.vue'),
    },

       {
        path: '/requisitions',
        name: 'requisitions',
        component: () => import('../views/requisitions/index.vue'),
    },

           {
        path: '/requisitions/:status_id',
        name: 'requisitions',
        component: () => import('../views/requisitions/index.vue'),
    },

      {
        path: '/requisition/:type/:type_id',
        name: 'requisition-type',
        component: () => import('../views/requisitions/typeRequisition.vue'),
    },

      {
        path: '/requisition-group/:approval_group_id/:status_id',
        name: 'requisition-group',
        component: () => import('../views/requisitions/requisitionGroup.vue'),
    },

          {
        path: '/requisitions/sheet',
        name: 'requisition-sheet',
        component: () => import('../views/requisitions/sheet.vue'),
    },

       {
        path: '/requisition/:requisition_id',
        name: 'requisition-individual',
        component: () => import('../views/requisitions/individual.vue'),
    },



       {
        path: '/good-issue-notes',
        name: 'good-issue-notes',
        component: () => import('../views/goodIssueNotes/index.vue'),
    },


       {
        path: '/good-issue-notes/:requisition_type_id',
        name: 'good-issue-notes-list',
        component: () => import('../views/goodIssueNotes/issueNote.vue'),
    },

               {
        path: '/good-delivery-notes',
        name: 'good-delivery-notes',
        component: () => import('../views/goodIssueNotes/goodDeliveryNote.vue'),
    },
        {
        path: '/orders2',
        name: 'orders2',
        component: () => import('../views/orders/preview2.vue'),
    },

      {
        path: '/bushman/orders',
        name: 'bushman-orders',
        component: () => import('../views/orders/bushman/'),
    },
    
        {
        path: '/general/orders',
        name: 'general-orders',
        component: () => import('../views/orders/general/'),
    },

    {
        path: '/copex-order-items/:order_id',
        name: 'copex-order-items',
        component: () => import('../views/orders/copex_items_list.vue'),
    },

    {
        path: '/bushman-order-items/:order_id',
        name: 'bushman-order-items',
        component: () => import('../views/orders/bushman_items_list.vue'),
    },

       {
        path: '/masters/ai',
        name: 'masters-ai',
        component: () => import('../views/masters/ai.vue'),
    },

    
       {
        path: '/masters/module-status',
        name: 'masters-module-status',
        component: () => import('../views/masters/moduleStatus.vue'),
    },

        {
        path: '/masters/approval-groups',
        name: 'masters-approval-groups',
        component: () => import('../views/masters/approvalManagement/approvalGroups.vue'),
    },
        
                   {
        path: '/masters/cards',
        name: 'masters-cards',
        component: () => import('../views/masters/cards.vue'),
    },

                       {
        path: '/masters/conversion-factors',
        name: 'conversion-factors',
        component: () => import('../views/masters/conversionFactor.vue'),
    },


    
      {
        path: '/approval-chains/:group_id',
        name: 'approval-chains',
        component: () => import('../views/approvalChain/'),
    },

          {
        path: '/approval-chain/:approval_list_id',
        name: 'approval-chains-individual',
        component: () => import('../views/approvalChain/individual.vue'),
    },

      {
        path: '/approval-chains/sheet/:group_id',
        name: 'approval-chain-sheet',
        component: () => import('../views/approvalChain/sheet.vue'),
    },
    
     {
        path: '/approval/:approval_id',
        name: 'approval',
        component: () => import('../views/approvalChain/approval.vue'),
    },


            {
        path: '/masters/addresses',
        name: 'masters-addresses',
        component: () => import('../views/masters/addresses.vue'),
    },



            {
        path: '/masters/labours',
        name: 'masters-labours',
        component: () => import('../views/masters/labour.vue'),
    },

                {
        path: '/masters/labour-request',
        name: 'masters-labour-request',
        component: () => import('../views/masters/labourRequest.vue'),
    },


        {
        path: '/masters/labour-type',
        name: 'masters-labour-type',
        component: () => import('../views/hr/labour/labourType.vue'),
    },

    
        {
        path: '/masters/lpo-items',
        name: 'masters-lpo-items',
        component: () => import('../views/masters/lpoItems.vue'),
    },

    {
        path: '/masters/machines',
        name: 'masters-machines',
        component: () => import('../views/masters/machines.vue'),
    },

      {
        path: '/masters/machine-type',
        name: 'masters-machine-type',
        component: () => import('../views/masters/machine_type.vue'),
    },

    {
        path: '/masters/service',
        name: 'masters-service',
        component: () => import('../views/masters/service.vue'),
    },



    {
        path: '/masters/employees',
        name: 'masters-employees',
        component: () => import('../views/masters/employees.vue'),
    },

    {
        path: '/masters/items-list',
        name: 'masters-items',
        component: () => import('../views/masters/items/dashboard.vue'),
    },

        {
        path: '/masters/item-categories',
        name: 'masters-item-categories',
        component: () => import('../views/masters/items/category.vue'),
    },

      {
        path: '/masters/logs',
        name: 'masters-logs',
        component: () => import('../views/masters/logs.vue'),
    },
    {
        path: '/masters/units',
        name: 'masters-units',
        component: () => import('../views/masters/units.vue'),
    },
    {
        path: '/masters/users',
        name: 'masters-users',
        component: () => import('../views/masters/users.vue'),
    },
    {
        path: '/masters/role',
        name: 'masters-roles',
        component: () => import('../views/masters/role.vue'),
    },

    {
        path: '/masters/role-permissions',
        name: 'masters-role-permissions',
        component: () => import('../views/masters/rolePermissions.vue'),
    },


    
    {
        path: '/masters/permissions',
        name: 'masters-permission',
        component: () => import('../views/masters/permission.vue'),
    },

    {
        path: '/masters/projects',
        name: 'masters-projects',
        component: () => import('../views/projects/list.vue'),
    },

     {
        path: '/masters/menus',
        name: 'masters-menus',
        component: () => import('../views/masters/menus/index.vue'),
    },

        {
        path: '/masters/remark-records',
        name: 'masters-remark-records',
        component: () => import('../views/masters/remark_records.vue'),
    },

            {
        path: '/masters/regions',
        name: 'region-masters',
        component: () => import('../views/masters/regions.vue'),
    },

    {
        path: '/user/profile',
        name: 'user-profile',
        component: () => import('../views/user/profile.vue'),
    },
   

      {
        path: '/chats',
        name: 'system-chats',
        component: () => import('../views/chats/dashboard.vue'),
    },


    {
        path: '/company/copex',
        name: 'copex-company',
        component: () => import('../views/companies/copex/dashboard.vue'),
    },

        {
        path: '/company/copex2',
        name: 'copex-company2',
        component: () => import('../views/companies/copex/dashboard2.vue'),
    },

    {
        path: '/company/bushman',
        name: 'bushman-company',
        component: () => import('../views/companies/bushman/dashboard.vue'),
    },

    {
        path: '/assets/spares',
        name: 'assets-spares',
        component: () => import('../views/assets/spares_list.vue'),
    },

       {
        path: '/assets/fuel-statement/:asset_id',
        name: 'assets-fuel-statement',
        component: () => import('../views/assets/fuelStatement.vue'),
    },

//report router paths

       {
          path: '/report/fuel-consumption',
        name: 'fuel-consumption-report',
        component: () => import('../views/report/fuelConsumption.vue'),
    },


     {
        path: '/report/item-budget/:project_id/:budget_id',
        name: 'item-budget-report',
        component: () => import('../views/report/item_budget.vue'),
    },

       {
        path: '/report/labour-payments/:labour_request_id',
        name: 'labour-payments-report',
        component: () => import('../views/report/labourPayments.vue'),
    },

    {
        path: '/budgets',
        name: 'budgets',
        // component: () => import('../views/budgets/index.vue'),
        component: () => import('../views/budgets/index.vue'),

    },

         {
        path: '/report/workReport',
        name: 'Work Report',
        component: () => import(/* webpackChunkName: "components-tabs" */ '../views/report/workReport.vue'),
    },

    {
  path: '/report/Report/:store_id',
  name: 'Report',
  component: () => import('../views/report/Report.vue'),
  props: true
},

        {
        path: '/test/',
        name: 'test',
         component: () => import('../views/test/index.vue'),
    },

     {
        path: '/budget-analysis',
        name: 'budget-analysis',
        component: () => import('../views/budgets/analysis.vue'),
    },


    // analysis router paths

         {
        path: '/analysis/project',
        name: 'project-analysis',
        component: () => import('../views/analysis/project.vue'),
    },




    



      {
        path: '/budget/allocation/:budget_id',
        name: 'budget-allocation',
        component: () => import('../views/budgets/allocation.vue'),
    },

          {
        path: '/budget-approvals/:budget_id',
        name: 'budget-approvals',
        component: () => import('../views/budgets/budgetApprovalList.vue'),
    },

      {
        path: '/inquiry',
        name: 'inquiry',
        component: () => import('../views/masters/inquiry.vue'),
    },



       {
        path: '/requisition-budget/:budget_item_description_id',
        name: 'requisition-budget',
        component: () => import('../views/budgets/requisitionBudget.vue'),
    },

    {
        path: '/report/project-budgets/:project_id',
        name: 'project-budgets-report',
        component: () => import('../views/report/projectBudgets.vue'),
    },

    {
        path: '/report/machine-usage/:machine_id',
        name: 'machine-usage-report',
        component: () => import('../views/report/machine_report.vue'),
    },

{
    path: '/report/boq',
    name: 'boq-report',
    component: () => import('../views/report/boq.vue'),
},

{
    path: '/report/allowance',
    name: 'allowance-report',
    component: () => import('../views/report/allowance.vue'),
},

{
    path: '/report/allowance-approved/:project_id/:request_id/:date',
    name: 'allowance-approved-report',
    component: () => import('../views/report/allowanceApproved.vue'),
},

{
    path: '/report/allocation',
    name: 'allocation-report',
    component: () => import('../views/report/allocation.vue'),
},

 {
        path: '/projects/dashboard',
        name: 'projects-overview',
        component: () => import('../views/projects/index.vue'),
    },

     {
        path: '/projects/planning',
        name: 'projects-planning',
        component: () => import('../views/projects/planning.vue'),
    },



     {
        path: '/payment',
        name: 'payment',
        component: () => import('../views/payment/index.vue'),
    },


      {
        path: '/labour-request',
        name: 'labour-request',
        component: () => import('../views/labours/labour_request.vue'),
    },
// 25 june 2025

      {
        path: '/good-received-notes/dashboard',
        name: 'good-received-notes-dashboard',
        component: () => import('../views/goodReceivedNotes/dashboard.vue'),
    },

      {
        path: '/good-received-notes/shortage-statement',
        name: 'good-received-notes-shortage',
        component: () => import('../views/goodReceivedNotes/shortage_statement.vue'),
    },


        {
        path: '/stores/conversion-history',
        name: 'stores-conversion-history',
        component: () => import('../views/stores/stockConversion.vue'),
    },


            {
        path: '/stores/dashboard',
        name: 'stores-dashboard',
          component: () => import('../views/stores/dashboard.vue'),
    },

                {
        path: '/stores/list',
        name: 'stores-list',
        component: () => import('../views/stores/list.vue'),
    },

        {
        path: '/stores/bin-cards',
        name: 'stores-bin-cards',
        component: () => import('../views/stores/binCard.vue'),
    },
      {
        path: '/gate-passes',
        name: 'gate-passes',
        component: () => import('../views/stores/gatePasses.vue'),
    },

       {
        path: '/stores/return-notes/:store_id',
        name: 'stores-return-notes',
        component: () => import('../views/goodReturnNotes/returnNotes.vue'),
    },

           {
        path: '/stores/return-notes/delivered',
        name: 'stores-return-notes-delivered',
        component: () => import('../views/goodReturnNotes/delivered.vue'),
    },

    
           {
        path: '/stores/return-notes/pending',
        name: 'stores-return-notes-pending',
        component: () => import('../views/goodReturnNotes/pending.vue'),
    },
        {
        path: '/logs/deleted-orders',
        name: 'logs-deleted-orders',
        component: () => import('../views/logs/deletedOrders.vue'),
    },




     {
          path: '/subcontractors/agreements',
        name: 'subcontractors-agreements',
        component: () => import('../views/subcontractors/index.vue'),
    },

    
       {
          path: '/subcontractor/:agreement_id',
        name: 'subcontractor',
         component: () => import('../views/subcontractors/individual.vue'),
    },

     {
          path: '/subcontractors/list',
        name: 'subcontractor-index',
        component: () => import('../views/subcontractors/list.vue'),
    },

        {
          path: '/summary/dashboard',
        name: 'summary-dashboard',
        component: () => import('../views/summary/'),
    },



    {
        path: '/accounts/dashboard',
        name: 'accounts-dashboard',
       component: () => import('../views/accounts/index.vue'),
    },
    
    {
        path: '/accounts/payments',
        name: 'accounts-payments',
       component: () => import('../views/accounts/payments.vue'),
    },

        {
        path: '/accounts/transaction-points',
        name: 'accounts-list',
       component: () => import('../views/accounts/transactionPoints.vue'),
    },

    {
        path: '/account-budgets',
        name: 'accounts-budget',
       component: () => import('../views/accounts/budgets.vue'),
    },


        {
        path: '/accounts/ledger',
        name: 'accounts-ledger',
       component: () => import('../views/accounts/ledger.vue'),
    },

    
        {
        path: '/accounts/deleted-orders',
        name: 'accounts-deleted-orders',
       component: () => import('../views/approvalChain/deletedOrders.vue'),
    },


        {
        path: '/attendances/list',
        name: 'remote-attendance',
       component: () => import('../views/attendances/geoLocation.vue'),
    },
    
        {
        path: '/attendances/individual',
        name: 'attendances-individual',
       component: () => import('../views/attendances/individual.vue'),
    },

            {
        path: '/supervisor-attendance/:store_id',
        name: 'site-attendance',
       component: () => import('../views/attendances/siteAttendance.vue'),
    },


    // hr Router paths

                       {
        path: '/hr/attendances/labours',
        name: 'hr-labour-attendances',
       component: () => import('../views/hr/labour/attendances.vue'),
    },


                   {
        path: '/hr/dashboard',
        name: 'hr-dashboard',
       component: () => import('../views/hr/dashboard.vue'),
    },

                {
        path: '/hr/attendances/dashboard',
        name: 'employees-attendance-dashboard',
       component: () => import('../views/hr/attendance.vue'),
    },
                    {
        path: '/hr/employees-attendance',
        name: 'employees-attendance',
       component: () => import('../views/hr/employees/attendance.vue'),
    },

    
                {
        path: '/hr/employees-list',
        name: 'employees-list',
       component: () => import('../views/hr/employees/list.vue'),
    },

                    {
        path: '/hr/employees/debts',
        name: 'employees/debts',
       component: () => import('../views/hr/employees/debts.vue'),
    },


    
                    {
        path: '/hr/employees/absence',
        name: 'employees-absence',
       component: () => import('../views/hr/employees/absence.vue'),
    },

                        {
        path: '/hr/employees/payroll',
        name: 'employees-payroll',
       component: () => import('../views/hr/employees/payroll.vue'),
    },

          {
        path: '/hr/employees/ghrm-list',
        name: 'ghrm-employees-list',
       component: () => import('../views/hr/employees/ghrm.vue'),
    },

                    {
        path: '/hr/leaves/list',
        name: 'hr-leaves-list',
       component: () => import('../views/hr/leaves/list.vue'),
    },

                        {
        path: '/hr/leaves/encashment/list',
        name: 'hr-leaves-encashment-list',
       component: () => import('../views/hr/encashment/list.vue'),
    },

                            {
        path: '/hr/leaves/encashment/request',
        name: 'hr-leaves-encashment-request',
       component: () => import('../views/hr/encashment/request.vue'),
    },

                                {
        path: '/hr/leaves/encashment/history',
        name: 'hr-leaves-encashment-list',
       component: () => import('../views/hr/encashment/list.vue'),
    },


    
    
    

                        {
        path: '/hr/leaves/balance',
        name: 'hr-leaves-balance',
       component: () => import('../views/hr/leaves/balance.vue'),
    },

                        {
        path: '/hr/leaves/request',
        name: 'hr-leaves-request',
       component: () => import('../views/hr/leaves/request.vue'),
    },

             {
        path: '/hr/labour/debts',
        name: 'hr-labour-debts',
        component: () => import('../views/hr/labour/debts.vue'),
    },

                {
        path: '/hr/labour/list',
        name: 'hr-labour-list',
        component: () => import('../views/hr/labour/list.vue'),
    },

    
            {
        path: '/hr/labour/rates',
        name: 'hr-labour-rates',
        component: () => import('../views/hr/labour/labourType.vue'),
    },

                 {
        path: '/hr/labour/vouchers',
        name: 'hr-labour-vouchers',
        component: () => import('../views/hr/labour/paymentRequests.vue'),
    },

                     {
        path: '/hr/labour/payment-requests',
        name: 'hr-labour-payment-requests',
        component: () => import('../views/hr/labour/issueRequest.vue'),
    },
                     {
        path: '/hr/labour/payment-requests',
        name: 'hr-labour-payment-requests',
        component: () => import('../views/hr/labour/issueRequest.vue'),
    },


                {
        path: '/hr/meetings/',
        name: 'hr-meetings',
        component: () => import('../views/hr/meetings/index.vue'),
    },



// vendor router paths
    {
        path: '/vendors/dashboard',
        name: 'vendors-dashboard',
        component: () => import('../views/vendors/'),
    },

    {
        path: '/vendors/list',
        name: 'vendors-list',
        component: () => import('../views/vendors/list.vue'),
    },

        {
        path: '/vendors/accounts',
        name: 'vendors-accounts',
        component: () => import('../views/vendors/accounts.vue'),
    },

    //29 jan 2026
    
      {
        path: '/good-received-notes/pendingItems',
        name: 'good-received-notes-pendingItems',
        component: () => import('../views/goodReceivedNotes/pendingGrnItems.vue'),
    },


            {
        path: '/accounts/statements',
        name: 'stetement-of-accounts',
        component: () => import('../views/statementOfAccounts.vue'),
    },

    {
        path: '/accounts/statements/:bin_card_id',
        name: 'statements',
        component: () => import('../views/statement.vue'),
    },

    {
        path: '/accounts/bincard/category/:category_id',
        name: 'bincard-category',
        component: () => import('../views/accounts/bincards.vue'),
    },

      {
        path: '/locations',
        name: 'location',
        component: () => import('../views/masters/location.vue'),
    },

    {
        path: '/jobcards/transfer-notes',
        name: 'jobcards-transfer-notes',
        component: () => import('../views/jobcards/jobcardTransferNotes.vue'),
    },

    
      {
        path: '/erp-attachments',
        name: 'erp-attachments',
        component: () => import('../views/masters/erpAttachments.vue'),
    },

        {
        path: '/jobcard/outside/:jobcard_id',
        name: 'external-jobcards',
        component: () => import('../views/jobcards/outsideJobcard.vue'),
    },

    
        {
        path: '/master-piece',
        name: 'master-piece',
        component: () => import('../layouts/sidebar-layout.vue'),
    },

];

const router = new createRouter({
    // mode: 'history',
    history: createWebHashHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.layout && to.meta.layout == 'auth') {
        store.commit('setLayout', 'auth');
    } else {
        store.commit('setLayout', 'app');
    }
    next(true);
});

export default router;
